import requests from '.././requests.service';
import { collectionContainersMockResponse } from '@/services/collections/collection-containers.mock';

const baseUrl = `${process.env.VUE_APP_ADMIN_PANEL_BASE_URL}/admin/v1`;

export const fetchCollectionContainers = async ({ isMock, limit }) => isMock ? collectionContainersMockResponse : requests.get(`${baseUrl}/collection-containers`, { params: { limit } });
